import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './css/Onboarding.css';

import axios from 'axios';

import { getUser, getToken } from './service/AuthService';


//TODO: move this to an environment variable
const onboardingrUrl = 'https://lkrse43p4g.execute-api.us-east-1.amazonaws.com/dev/onboarding';


const Onboarding = () => {
    const user = getUser();
    const token = getToken();
    const username = user !== 'undefined' && user ? user.username: '';

    const [age, setAge] = useState('');
    const [gender, setGender] = useState('');
    const [timeSpent, setTimeSpent] = useState('');
    const [percentageProductive, setPercentageProductive] = useState('');
    const [productiveUseCase, setProductiveUseCase] = useState('');
    const [joiningReason, setJoiningReason] = useState('');
    const [failedTreatments, setFailedTreatments] = useState('');
    const [bestTreatment, setBestTreatment] = useState('');
    const [failureReasons, setFailureReasons] = useState('');
    const [problematicTools, setProblematicTools] = useState('');
    const [problematicBehaviors, setProblematicBehaviors] = useState('');
    const [initialUseScore, setInitialUseScore] = useState('');
    const [currentGoal, setCurrentGoal] = useState('');
    const [caplanScalePOSI1, setCaplanScalePOSI1] = useState('');
    const [caplanScalePOSI2, setCaplanScalePOSI2] = useState('');
    const [caplanScalePOSI3, setCaplanScalePOSI3] = useState('');

    const [caplanScaleMR1, setCaplanScaleMR1] = useState('');
    const [caplanScaleMR2, setCaplanScaleMR2] = useState('');
    const [caplanScaleMR3, setCaplanScaleMR3] = useState('');
    const [caplanScaleCP1, setCaplanScaleCP1] = useState('');
    const [caplanScaleCP2, setCaplanScaleCP2] = useState('');
    const [caplanScaleCP3, setCaplanScaleCP3] = useState('');
    const [caplanScaleCIU1, setCaplanScaleCIU1] = useState('');

    const [caplanScaleCIU2, setCaplanScaleCIU2] = useState('');
    const [caplanScaleCIU3, setCaplanScaleCIU3] = useState('');
    const [caplanScaleNO1, setCaplanScaleNO1] = useState('');
    const [caplanScaleNO2, setCaplanScaleNO2] = useState('');
    const [caplanScaleNO3, setCaplanScaleNO3] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

     //Popup
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [showPopup, setShowPopup] = useState(false);

    //Popup UI
    const [ageUI, setAgeUI] = useState('');
    const [genderUI, setGenderUI] = useState('');
    const [timeSpentUI, setTimeSpentUI] = useState('');
    const [percentageProductiveUI, setPercentageProductiveUI] = useState('');
    const [productiveUseCaseUI, setProductiveUseCaseUI] = useState('');
    const [joiningReasonUI, setJoiningReasonUI] = useState('');
    const [failedTreatmentsUI, setFailedTreatmentsUI] = useState('');
    const [bestTreatmentUI, setBestTreatmentUI] = useState('');
    const [failureReasonsUI, setFailureReasonsUI] = useState('');
    const [problematicToolsUI, setProblematicToolUI] = useState('');
    const [problematicBehaviorsUI, setProblematicBehaviorsUI] = useState('');
    const [initialUseScoreUI, setInitialUseScoreUI] = useState('');
    const [currentGoalUI, setCurrentGoaUIl] = useState('');
    const [caplanScalePOSI1UI, setCaplanScalePOSI1UI] = useState('');
    const [caplanScalePOSI2UI, setCaplanScalePOSI2UI] = useState('');
    const [caplanScalePOSI3UI, setCaplanScalePOSI3UI] = useState('');

    const [caplanScaleMR1UI, setCaplanScaleMR1UI] = useState('');
    const [caplanScaleMR2UI, setCaplanScaleMR2UI] = useState('');
    const [caplanScaleMR3UI, setCaplanScaleMR3UI] = useState('');
    const [caplanScaleCP1UI, setCaplanScaleCP1UI] = useState('');
    const [caplanScaleCP2UI, setCaplanScaleCP2UI] = useState('');
    const [caplanScaleCP3UI, setCaplanScaleCP3UI] = useState('');
    const [caplanScaleCIU1UI, setCaplanScaleCIU1UI] = useState('');

    const [caplanScaleCIU2UI, setCaplanScaleCIU2UI] = useState('');
    const [caplanScaleCIU3UI, setCaplanScaleCIU3UI] = useState('');
    const [caplanScaleNO1UI, setCaplanScaleNO1UI] = useState('');
    const [caplanScaleNO2UI, setCaplanScaleNO2UI] = useState('');
    const [caplanScaleNO3UI, setCaplanScaleNO3UI] = useState('');

    const navigate = useNavigate()

    const submitHandler = (event) => {
        //console.log('start')
        event.preventDefault();
        if(age === '' || gender === '' || timeSpent === '' || percentageProductive === '' || productiveUseCase === '' || joiningReason === '' || failedTreatments === '' || failureReasons === '' || problematicTools === '' || problematicBehaviors === '' || initialUseScore === '' || caplanScalePOSI1 === '' || caplanScalePOSI2 === '' || caplanScaleMR1 === '' || caplanScaleMR2 === '' || caplanScaleMR3 === '' || caplanScaleCP1 === '' || caplanScaleCP2 === '' || caplanScaleCP3 === '' || caplanScaleCIU1 === '' || caplanScaleCIU2 === '' || caplanScaleCIU3 === '' || caplanScaleNO1 === '' || caplanScaleNO2 === '' || caplanScaleNO3 === ''){
            setErrorMessage('All fields are required');
            return;
        }

        //console.log('passed check')
        setErrorMessage(null)
        
        //TODO: move this to an environment variable
        const requestConfig = {
            headers: {
                'x-api-key': 'mCQrNSvy7X5AUdJlF2ybc3LdEFGndN885kzttyvB'
            }
        }

        const requestBody = {
            username: username,
            token: token,
            age: age,
            gender: gender.target.value,
            timeSpent: timeSpent,
            percentageProductive: percentageProductive,
            productiveUseCase: productiveUseCase,
            joiningReason: joiningReason.target.value,
            failedTreatments: failedTreatments,
            bestTreatment: bestTreatment,
            failureReasons: failureReasons,
            problematicTools: problematicTools.target.value,
            problematicBehaviors: problematicBehaviors,
            initialUseScore: initialUseScore,
            currentGoal: currentGoal,
            caplanScalePOSI1: caplanScalePOSI1,
            caplanScalePOSI2: caplanScalePOSI2,
            caplanScalePOSI3: caplanScalePOSI3,
            caplanScaleMR1: caplanScaleMR1,
            caplanScaleMR2: caplanScaleMR2,
            caplanScaleMR3: caplanScaleMR3,
            caplanScaleCP1: caplanScaleCP1,
            caplanScaleCP2: caplanScaleCP2,
            caplanScaleCP3: caplanScaleCP3,
            caplanScaleCIU1: caplanScaleCIU1,
            caplanScaleCIU2: caplanScaleCIU2,
            caplanScaleCIU3: caplanScaleCIU3,
            caplanScaleNO1: caplanScaleNO1,
            caplanScaleNO2: caplanScaleNO2,
            caplanScaleNO3: caplanScaleNO3            
        }


        //console.log(requestBody)
        axios.post(onboardingrUrl, requestBody, requestConfig).then(response => {
            // setUserSession(response.data.user, response.data.token);
            //console.log('blep')

            navigate('/daily-content');
        }).catch(error => {
            //TODO: fix error of receiving null error
            if(error.response.status === 401 || error.response.status === 403 ){
                setErrorMessage(error.response.data.message);
            }
            else{
                setErrorMessage('Sorry the server is down. Please try again later.');

            }
        })
    }

     
    //Popup
    const questions = [
        {
            assets: ageUI
        },
        {
            assets: genderUI
        },
        {
            assets: timeSpentUI
        },
        {
            assets: percentageProductiveUI
        },
        {
            assets: productiveUseCaseUI
        },
        {
            assets: joiningReasonUI
        },
        {
            assets: failedTreatmentsUI
        },
        {
            assets: bestTreatmentUI
        },
        {
            assets: failureReasonsUI
        },
        {
            assets: problematicToolsUI
        },
        {
            assets: problematicBehaviorsUI
        },
        {
            assets: initialUseScoreUI
        },
        {
            assets: currentGoalUI
        },
        {
            assets: caplanScalePOSI1UI
        },
        {
            assets: caplanScalePOSI2UI
        },
        {
            assets: caplanScalePOSI3UI
        },
        {
            assets: caplanScaleMR1UI
        },
        {
            assets: caplanScaleMR2UI
        },
        {
            assets: caplanScaleMR3UI
        },
        {
            assets: caplanScaleCP1UI
        },
        {
            assets: caplanScaleCP2UI
        },
        {
            assets: caplanScaleCP3UI
        },
        {
            assets: caplanScaleCIU1UI
        },
        {
            assets: caplanScaleCIU2UI
        },
        {
            assets: caplanScaleCIU3UI
        },
        {
            assets: caplanScaleNO1UI
        },
        {
            assets: caplanScaleNO2UI
        },
        {
            assets: caplanScaleNO3UI
        },
        // Add more questions as needed
    ];

    const handleNextQuestion = () => {
        setCurrentQuestion(currentQuestion + 1);
    };

    const handlePreviousQuestion = () => {
        setCurrentQuestion(currentQuestion - 1);
    };

    const handleSelectOption = (selectedOption) => {
        // Update the selected option as the answer for the current question
        const updatedAnswers = [...answers];
        updatedAnswers[currentQuestion] = selectedOption;
        setAnswers(updatedAnswers);
    };

    const handleInputChange = (inputValue) => {
        // Update the input value as the answer for the current question
        const updatedAnswers = [...answers];
        updatedAnswers[currentQuestion] = inputValue;
        setAnswers(updatedAnswers);
    };

    const handleSubmit = () => {
        // Process form submission or save answers
        // For example, you can send the answers to a backend server here

        // Show a success message or close the popup form
    };
    const handleOpenPopup = () => {
        setShowPopup(true);
        document.getElementsByClassName("popup-container")[0].style.visibility =  "visible"
    };

    const handleClosePopup = () => {
        setShowPopup(false);
        setCurrentQuestion(0); // Reset the current question when the popup is closed
        setAnswers([]); // Clear the answers when the popup is closed
        document.getElementsByClassName("popup-container")[0].style.visibility =  "hidden"

    };

    const renderForm = () => {
        const currentQ = questions[currentQuestion];
        const { question, options } = currentQ;

        return (
        <div className="form-container">
            <div className="button-group" style={{ float: 'right' }}>
            <button onClick={handleClosePopup}>Close </button>
            </div>
            <h2>{question}</h2>
            {currentQ.assets}
            <div className="button-group" style={{ marginTop: '1.2rem' }}>
            {currentQuestion > 0 && (
                <button onClick={handlePreviousQuestion}>Previous</button>
            )}
            {currentQuestion < questions.length - 1 ? (
                <button onClick={handleNextQuestion} style={{ float: 'right' }}>Next</button>
            ) : (
                <button onClick={handleSubmit} style={{ float: 'right' }}>Submit</button>
            )}
            </div>
        </div>
        );
    };
    // useEffect(() => {
    //     setAgeUI(<div className="form-group"> 
    //                         <label> How old are you? </label> 
    //                         <br/> 
    //                         <input type="number" value={age} onChange={event => setAge(event.target.value)} /> <br />
    //                     </div>)
    //     setGenderUI(<div className="form-group"> 
    //                         <label> Sex at birth?: </label> 
    //                         <br /> 
    //                         <br />
    //                         <div className="container">
    //                             <div className="item">
    //                                 <p>Male</p>
    //                                 <p>Female</p>
    //                             </div>
    //                             <div className="item" onChange={setGender}>
    //                                 <p><input type="radio" value="Male" name="gender" /></p>
    //                                 <p><input type="radio" value="Female" name="gender" /></p>
    //                             </div>
    //                         </div>
    //                     </div>)
    //     setTimeSpentUI(<div className="form-group"><label> How long do you spend on average on the internet?: </label> <br /> <input type="number" placeholder='in hours' value={timeSpent} onChange={event => setTimeSpent(event.target.value)} /> <br /> </div>)
    //     setPercentageProductiveUI(<div className="form-group"><label> What percentage of that is productive use (school, work, etc.)?: </label><br /> <input type="number" placeholder='0-100' value={percentageProductive} onChange={event => setPercentageProductive(event.target.value)} /> <br /></div>)
    //     setProductiveUseCaseUI(<div className="form-group"><label> What is your primary productive use case?: </label><br /> <input type="text" value={productiveUseCase} onChange={event => setProductiveUseCase(event.target.value)} /> <br /></div>)
    //     setJoiningReasonUI(<div className="form-group">
    //                         <label> Why are you looking to improve your digital health?: </label>
    //                         <br /> 
    //                         {/* <input type="text" value={joiningReason} onChange={event => setJoiningReason(event.target.value)} />  */}
    //                         <div className="container">
    //                             <div className="item" onChange={setJoiningReason}>
    //                                 <div className="container"><span className="item">Decrease Anxiety</span><input className="radioButton" type="radio" value="decrease_anxiety" name="joiningReason" /></div>
    //                                 <div className="container"><span className="item">Improve wellbeing</span><input className="radioButton" type="radio" value="improve_wellbeing" name="joiningReason" /></div>
    //                                 <div className="container"><span className="item">Improve relationships</span><input className="radioButton" type="radio" value="improve_relationships" name="joiningReason" /></div>
    //                                 <div className="container"><span className="item">Improve physical health</span><input className="radioButton" type="radio" value="improve_physical_health" name="joiningReason" /></div>                                   
    //                                 <div className="container"><span className="item">Decrease loneliness</span><input className="radioButton" type="radio" value="decrease_loneliness" name="joiningReason" /></div>
    //                                 <div className="container"><span className="item">Increase self-fulfillment</span><input className="radioButton" type="radio" value="increase_self_fulfillment" name="joiningReason" /></div>
    //                                 <div className="container"><span className="item">Other</span><input className="radioButton" type="radio" value="other" name="joiningReason" /></div>

    //                             </div>
    //                         </div>
    //                         <br />
    //                     </div>)
    //     setFailedTreatmentsUI(<div className="form-group"><label> What have you tried?: </label><br /> <input type="text" placeholder='comma separated' value={failedTreatments} onChange={event => setFailedTreatments(event.target.value)} /> <br /></div>)
    //     setBestTreatmentUI(<div className="form-group"><label> What has worked best?: </label><br /> <input type="text" placeholder='from above' value={bestTreatment} onChange={event => setBestTreatment(event.target.value)} /> <br /></div>)
    //     setFailureReasonsUI(<div className="form-group"><label> Why hasn’t what you’ve tried worked long term?: </label><br /> <input type="text" value={failureReasons} onChange={event => setFailureReasons(event.target.value)} /> <br /></div>)
    //     setProblematicToolUI(<div className="form-group">
    //                         <label> On what devices do you show problematic tech use?: </label>
    //                         <br /> 
    //                         {/* <input type="text" placeholder='comma separated' value={problematicTools} onChange={event => setProblematicTools(event.target.value)} /> */}
    //                         <div className="container">
    //                             <div className="item" onChange={setProblematicTools}>
    //                                 <div className="container"><span className="item">Computer</span><input className="radioButton" type="radio" value="computer" name="problematicTools" /></div>
    //                                 <div className="container"><span className="item">Phone</span><input className="radioButton" type="radio" value="phone" name="problematicTools" /></div>
    //                                 <div className="container"><span className="item">Tablet</span><input className="radioButton" type="radio" value="tablet" name="problematicTools" /></div>
    //                                 <div className="container"><span className="item">Television</span><input className="radioButton" type="radio" value="television" name="problematicTools" /></div>                                   
    //                                 <div className="container"><span className="item">Other</span><input className="radioButton" type="radio" value="other" name="problematicTools" /></div>

    //                             </div>
    //                         </div>
    //                         <br />
    //                         <br />
    //                     </div>)
    //     setProblematicBehaviorsUI(<div className="form-group"><label> On what digital tools do you show problematic tech use? (applications or websites): </label><br /> <input type="text" placeholder='comma separated' value={problematicBehaviors} onChange={event => setProblematicBehaviors(event.target.value)} /> <br /></div>)
    //     setInitialUseScoreUI(<div className="form-group"><label> Rate your recent tech use? (1-10): </label><br /> <input type="number" placeholder='1 ("poor") - 10 ("excellent")' value={initialUseScore} onChange={event => setInitialUseScore(event.target.value)} /> <br /></div>)
    //     setCurrentGoaUIl(<div className="form-group"><label> If you had to pick one current life goal to complete in the next 3 months what would it be?: </label><br /> <input type="text" placeholder='Goal should be Specific, Measurable, Achievable, Relevant, and Time - Bound' value={currentGoal} onChange={event => setCurrentGoal(event.target.value)} /> <br /></div>)
    //     setCaplanScalePOSI1UI(<div className="form-group"><label> I prefer online social interaction over face-to-face communication: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScalePOSI1} onChange={event => setCaplanScalePOSI1(event.target.value)} /> <br /></div>)
    //     setCaplanScalePOSI2UI(<div className="form-group"><label> Online social interaction is more comfortable for me  than face-to-face interaction: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScalePOSI2} onChange={event => setCaplanScalePOSI2(event.target.value)} /> <br /></div>)
    //     setCaplanScalePOSI3UI(<div className="form-group"><label> I prefer communicating with people online rather than face to face: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScalePOSI3} onChange={event => setCaplanScalePOSI3(event.target.value)} /> <br /></div>)
    //     setCaplanScaleMR1UI(<div className="form-group"><label> I have used the Internet to talk with others when I was feeling isolated: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleMR1} onChange={event => setCaplanScaleMR1(event.target.value)} /> <br /></div>)
    //     setCaplanScaleMR2UI(<div className="form-group"><label> I have used the Internet to make myself feel better when I was down: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleMR2} onChange={event => setCaplanScaleMR2(event.target.value)} /> <br /></div>)
    //     setCaplanScaleMR3UI(<div className="form-group"><label> I have used the Internet to make myself feel better when I’ve felt upset: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleMR3} onChange={event => setCaplanScaleMR3(event.target.value)} /> <br /></div>)
    //     setCaplanScaleCP1UI(<div className="form-group"><label> When I haven’t been online for some time, I become preoccupied with the thought of going online: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleCP1} onChange={event => setCaplanScaleCP1(event.target.value)} /> <br /></div>)
    //     setCaplanScaleCP2UI(<div className="form-group"><label> I would feel lost if I was unable to go online: </label> <br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleCP2} onChange={event => setCaplanScaleCP2(event.target.value)} /> <br /></div>)
    //     setCaplanScaleCP3UI(<div className="form-group"><label> I think obsessively about going online when I am offline: </label> <br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleCP3} onChange={event => setCaplanScaleCP3(event.target.value)} /> <br /></div>)
    //     setCaplanScaleCIU1UI(<div className="form-group"> <label> I have difficulty controlling the amount of time I spend online: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleCIU1} onChange={event => setCaplanScaleCIU1(event.target.value)} /> <br /></div>)
    //     setCaplanScaleCIU2UI(<div className="form-group"><label> I find it difficult to control my Internet use: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleCIU2} onChange={event => setCaplanScaleCIU2(event.target.value)} /> <br /></div>)
    //     setCaplanScaleCIU3UI(<div className="form-group"><label> When offline, I have a hard time trying to resist the urge to go online: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleCIU3} onChange={event => setCaplanScaleCIU3(event.target.value)} /> <br /></div>)
    //     setCaplanScaleNO1UI( <div className="form-group"><label> My internet use has made it difficult for me to manage my life: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleNO1} onChange={event => setCaplanScaleNO1(event.target.value)} /> <br /></div>)
    //     setCaplanScaleNO2UI(<div className="form-group"><label> I have missed social engagements or activities because of my Internet use: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleNO2} onChange={event => setCaplanScaleNO2(event.target.value)} /> <br /></div>)
    //     setCaplanScaleNO3UI(<div className="form-group"><label> My Internet use has created problems for me in my life: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleNO3} onChange={event => setCaplanScaleNO3(event.target.value)} /> <br /></div>)
    // });

    return (
        <div className="container">
            <form onSubmit = { submitHandler }>
                 <div class="form-mask">
                    <div class="form-contents" style={{ maxHeight: '625px', margin: '0 auto', overflowY: 'auto', fontSize:'1.2rem', width:'95%', }}>
                        <h5>Onboarding</h5>
                        {/* <div className="popup">
                            <button onClick={handleOpenPopup}>hello</button>
                            <div className="popup-container" >{renderForm()}</div>
                        </div> */}
                        Demographic information <br />
                        <br />
                        <div className="form-group"> 
                            <label> How old are you? </label> 
                            <br/> 
                            <input type="number" value={age} onChange={event => setAge(event.target.value)} /> <br />
                        </div>
                        <div className="form-group"> 
                            <label> Sex at birth?: </label> 
                            <br /> 
                            <br />
                            <div className="container">
                                <div className="item">
                                    <p>Male</p>
                                    <p>Female</p>
                                </div>
                                <div className="item" onChange={setGender}>
                                    <p><input type="radio" value="Male" name="gender" /></p>
                                    <p><input type="radio" value="Female" name="gender" /></p>
                                </div>
                            </div>
                        </div>
                        <br />
                        Background information <br />
                        <br />
                        <div className="form-group"><label> How long do you spend on average on the internet?: </label> <br /> <input type="number" placeholder='in hours' value={timeSpent} onChange={event => setTimeSpent(event.target.value)} /> <br /> </div>
                        <div className="form-group"><label> What percentage of that is productive use (school, work, etc.)?: </label><br /> <input type="number" placeholder='0-100' value={percentageProductive} onChange={event => setPercentageProductive(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> What is your primary productive use case?: </label><br /> <input type="text" value={productiveUseCase} onChange={event => setProductiveUseCase(event.target.value)} /> <br /></div>
                        <div className="form-group">
                            <label> Why are you looking to improve your digital health?: </label>
                            <br /> 
                            {/* <input type="text" value={joiningReason} onChange={event => setJoiningReason(event.target.value)} />  */}
                            <div className="container">
                                <div className="item" onChange={setJoiningReason}>
                                    <div className="container"><span className="item">Decrease Anxiety</span><input className="radioButton" type="radio" value="decrease_anxiety" name="joiningReason" /></div>
                                    <div className="container"><span className="item">Improve wellbeing</span><input className="radioButton" type="radio" value="improve_wellbeing" name="joiningReason" /></div>
                                    <div className="container"><span className="item">Improve relationships</span><input className="radioButton" type="radio" value="improve_relationships" name="joiningReason" /></div>
                                    <div className="container"><span className="item">Improve physical health</span><input className="radioButton" type="radio" value="improve_physical_health" name="joiningReason" /></div>                                   
                                    <div className="container"><span className="item">Decrease loneliness</span><input className="radioButton" type="radio" value="decrease_loneliness" name="joiningReason" /></div>
                                    <div className="container"><span className="item">Increase self-fulfillment</span><input className="radioButton" type="radio" value="increase_self_fulfillment" name="joiningReason" /></div>
                                    <div className="container"><span className="item">Other</span><input className="radioButton" type="radio" value="other" name="joiningReason" /></div>

                                </div>
                            </div>
                            <br />
                        </div>
                        <div className="form-group"><label> What have you tried?: </label><br /> <input type="text" placeholder='comma separated' value={failedTreatments} onChange={event => setFailedTreatments(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> What has worked best?: </label><br /> <input type="text" placeholder='from above' value={bestTreatment} onChange={event => setBestTreatment(event.target.value)} /> <br /></div>

                        <div className="form-group"><label> Why hasn’t what you’ve tried worked long term?: </label><br /> <input type="text" value={failureReasons} onChange={event => setFailureReasons(event.target.value)} /> <br /></div>
                        <div className="form-group">
                            <label> On what devices do you show problematic tech use?: </label>
                            <br /> 
                            {/* <input type="text" placeholder='comma separated' value={problematicTools} onChange={event => setProblematicTools(event.target.value)} /> */}
                            <div className="container">
                                <div className="item" onChange={setProblematicTools}>
                                    <div className="container"><span className="item">Computer</span><input className="radioButton" type="radio" value="computer" name="problematicTools" /></div>
                                    <div className="container"><span className="item">Phone</span><input className="radioButton" type="radio" value="phone" name="problematicTools" /></div>
                                    <div className="container"><span className="item">Tablet</span><input className="radioButton" type="radio" value="tablet" name="problematicTools" /></div>
                                    <div className="container"><span className="item">Television</span><input className="radioButton" type="radio" value="television" name="problematicTools" /></div>                                   
                                    <div className="container"><span className="item">Other</span><input className="radioButton" type="radio" value="other" name="problematicTools" /></div>

                                </div>
                            </div>
                            <br />
                            <br />
                        </div>
                        <div className="form-group"><label> On what digital tools do you show problematic tech use? (applications or websites): </label><br /> <input type="text" placeholder='comma separated' value={problematicBehaviors} onChange={event => setProblematicBehaviors(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> Rate your recent tech use? (1-10): </label><br /> <input type="number" placeholder='1 ("poor") - 10 ("excellent")' value={initialUseScore} onChange={event => setInitialUseScore(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> If you had to pick one current life goal to complete in the next 3 months what would it be?: </label><br /> <input type="text" placeholder='Goal should be Specific, Measurable, Achievable, Relevant, and Time - Bound' value={currentGoal} onChange={event => setCurrentGoal(event.target.value)} /> <br /></div>
                        <br />
                        Internet use screeening tool <br />
                        <br />
                        {/* Preference for online social interaction <br /> */}
                        <div className="form-group"><label> I prefer online social interaction over face-to-face communication: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScalePOSI1} onChange={event => setCaplanScalePOSI1(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> Online social interaction is more comfortable for me  than face-to-face interaction: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScalePOSI2} onChange={event => setCaplanScalePOSI2(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> I prefer communicating with people online rather than face to face: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScalePOSI3} onChange={event => setCaplanScalePOSI3(event.target.value)} /> <br /></div>
                        {/* <br /> */}
                        {/* Mood regulation <br />
                        <br /> */}
                        <div className="form-group"><label> I have used the Internet to talk with others when I was feeling isolated: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleMR1} onChange={event => setCaplanScaleMR1(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> I have used the Internet to make myself feel better when I was down: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleMR2} onChange={event => setCaplanScaleMR2(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> I have used the Internet to make myself feel better when I’ve felt upset: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleMR3} onChange={event => setCaplanScaleMR3(event.target.value)} /> <br /></div>
                        {/* <br /> */}
                        {/* Cognitive preoccupation <br />
                        <br /> */}
                        <div className="form-group"><label> When I haven’t been online for some time, I become preoccupied with the thought of going online: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleCP1} onChange={event => setCaplanScaleCP1(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> I would feel lost if I was unable to go online: </label> <br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleCP2} onChange={event => setCaplanScaleCP2(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> I think obsessively about going online when I am offline: </label> <br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleCP3} onChange={event => setCaplanScaleCP3(event.target.value)} /> <br /></div>
                        {/* <br /> */}
                        {/* Compulsive internet use <br />
                        <br /> */}
                        <div className="form-group"> <label> I have difficulty controlling the amount of time I spend online: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleCIU1} onChange={event => setCaplanScaleCIU1(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> I find it difficult to control my Internet use: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleCIU2} onChange={event => setCaplanScaleCIU2(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> When offline, I have a hard time trying to resist the urge to go online: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleCIU3} onChange={event => setCaplanScaleCIU3(event.target.value)} /> <br /></div>
                        {/* <br /> */}
                        {/* Negative outcomes <br />
                        <br /> */}
                        <div className="form-group"><label> My internet use has made it difficult for me to manage my life: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleNO1} onChange={event => setCaplanScaleNO1(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> I have missed social engagements or activities because of my Internet use: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleNO2} onChange={event => setCaplanScaleNO2(event.target.value)} /> <br /></div>
                        <div className="form-group"><label> My Internet use has created problems for me in my life: </label><br /> <input type="number" min="1" max="8" placeholder='1 ("definitely disagree") - 8 ("definitely agree")' value={caplanScaleNO3} onChange={event => setCaplanScaleNO3(event.target.value)} /> <br /></div>
                        {errorMessage && <p className="message"> { errorMessage } </p>}
                        <div className="form-group"><input class="submit-bttn" type="submit" value="Submit" /><br /></div>
                    </div>
                 </div>
            </form>
        </div>
    )
}


export default Onboarding;